"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.retry = void 0;
/**
 * Copied mostly from @syntaxfanatics/peon
 *
 * @param opts
 */
function retry(opts, extra) {
    if (typeof opts.count !== 'number')
        throw new TypeError(`"count" must be a number. Given: "${typeof opts.count}"`);
    if (!Number.isFinite(opts.count))
        throw new TypeError(`"count" must be finite. Given: "${opts.count}"`);
    if (!(opts.count >= 0))
        throw new TypeError(`"count" must be gte 0. Given: "${opts.count}"`);
    return function (tryFn) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            let finalResult;
            let retries = 0;
            do {
                try {
                    // log halt
                    if ((retries > 0) && opts.afterMillis) {
                        if (extra === null || extra === void 0 ? void 0 : extra.verbose)
                            (_a = extra.logger) === null || _a === void 0 ? void 0 : _a.debug(`[retry::try] Pausing for "${opts.afterMillis}"ms before retrying "${tryFn.name}" for the "${retries}"st/nd/rd/th time of "${opts.count}"...`);
                        yield new Promise(res => setTimeout(res, opts.afterMillis));
                    }
                    // log try
                    if (retries > 0) {
                        if (extra === null || extra === void 0 ? void 0 : extra.verbose)
                            (_b = extra.logger) === null || _b === void 0 ? void 0 : _b.debug(`[retry::try] Retrying fn "${tryFn.name}" for "${retries}"st/nd/rd/th time of "${opts.count}"...`);
                    }
                    // attempt the fn
                    const result = yield tryFn();
                    finalResult = { success: true, win: result, error: null, };
                }
                catch (tryError) {
                    // get error & retry
                    if (extra === null || extra === void 0 ? void 0 : extra.verbose)
                        (_c = extra.logger) === null || _c === void 0 ? void 0 : _c.warn(`[retry::catch] Errored trying fn "${tryFn.name}" on "${retries}"st/nd/rd/th attempt of "${opts.count}"...`);
                    finalResult = { success: false, win: null, error: tryError, };
                }
            } while (!finalResult.success && (retries += 1) < opts.count);
            // success
            if (finalResult.success)
                return finalResult.win;
            // fail
            if (extra === null || extra === void 0 ? void 0 : extra.verbose)
                (_d = extra.logger) === null || _d === void 0 ? void 0 : _d.warn(`[retry] Exhausted "${opts.count}" retries to execute "${tryFn.name}", throwing latest error`);
            throw finalResult.error;
        });
    };
}
exports.retry = retry;
